<template>
  <section>
    <!-- <Notifications/> -->
    <ConfirmationDialogues ref="confirms" />
    <ImportantNotification />
    <GlobalAlerts ref="alerts" />
    <RouterView />
    <FloodModal />
  </section>
</template>

<script>
import dayjsEn from 'dayjs/locale/en';
import dayjsDe from 'dayjs/locale/de';
import dayjsEs from 'dayjs/locale/es';
import dayjsFr from 'dayjs/locale/fr';
import dayjsHe from 'dayjs/locale/he';
import dayjsPt from 'dayjs/locale/pt';
import dayjsRu from 'dayjs/locale/ru';
import dayjsTr from 'dayjs/locale/tr';
import dayjsBn from 'dayjs/locale/bn';

import { dayjs } from 'element-plus'; 
import { useElementLang } from '@/helpers/elementLang';
import { initResponsive, isNeedResponsiveChange } from '@/lib/responsive';
import i18n from '@/i18n';
import FloodModal from '@/components/FloodModal.vue';
import ImportantNotification from '@/views/Notifications/ImportantNotification.vue';
import eventBus from '@/lib/eventBus';
import config from './config';


export default {
  name: 'App',
  components: { FloodModal, ImportantNotification },
  data() {
    return {};
  },
  computed: {
    onWindowResizeDebounced() {
      return this.$_.debounce(this.onWindowResize, 50);
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.headersLocale();
    },
    $route(to, from) {
      document.body.setAttribute('data-route', to.name);
      document.title = `${this.$t(to.name)} - ${this.$config.pageTitle}`;
    },
  },
  mounted() {
    const routeName = this.$route.name || '';
    document.title = `${this.$t(routeName)} - ${this.$config.pageTitle}`;
    document.body.setAttribute('data-route', this.$route.name);
    document.querySelector('.pre-loading').style.display = 'none';
    window.addEventListener('resize', this.onWindowResizeDebounced);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResizeDebounced);
  },
  updated() {
    document.body.setAttribute('data-route', this.$route.name);
  },
  created() {
    document.body.setAttribute('data-theme', this.$config.theme);
    if (localStorage.getItem('language') === null) {
      const langs = Object.keys(i18n.global.messages.value);
      const locLang = window.navigator.language.substr(0, 2).toLowerCase();
      this.$locale.value = langs.includes(locLang) ? locLang : 'en';
      localStorage.setItem('language', this.$locale.value);
    } else {
      this.$locale.value = localStorage.getItem('language');
    }
    this.headersLocale();

    document.body.setAttribute('data-language', this.$locale.value);
    moment.locale(this.$locale.value);
    initResponsive();
  },
  methods: {
    headersLocale() {
      document.body.setAttribute('data-language', this.$locale.value);
      localStorage.setItem('language', this.$locale.value);
      this.$api.affiliates.defaults.headers.common['X-Selected-Locale'] = this.$locale.value || 'en';
      this.$api.misc.defaults.headers.common['X-Selected-Locale'] = this.$locale.value || 'en';
      this.$api.affiliates.defaults.headers.common['X-Customer-Id'] = config.customerId;
      this.$api.misc.defaults.headers.common['X-Customer-Id'] = config.customerId;
      const routeName = this.$route.name || '';
      document.title = `${this.$t(routeName)} - ${this.$config.pageTitle}`;
      if (this.$moment) {
        this.$moment.locale(this.$locale.value);

        const dayjsLangIndex = {
          en: dayjsEn,
          de: dayjsDe,
          es: dayjsEs,
          fr: dayjsFr,
          he: dayjsHe,
          pt: dayjsPt,
          ru: dayjsRu,
          tr: dayjsTr,
          bn: dayjsBn,
        };
    
        dayjs.locale(dayjsLangIndex[this.$locale.value]);
      }

      setTimeout(() => {
        moment.locale(this.$locale.value);
      }, 300);
    },
    onWindowResize() {
      if (isNeedResponsiveChange()) {
        const state = initResponsive();
        this.$store.commit('saveBreakthrough', state);
      }
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/theme/default/common/index';
</style>
